import React from "react";
import { motion } from "framer-motion";
import { buildWhatsAppLink } from "../data/menu";
import { Flourish } from "./brand/Ornaments";

const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      className="relative py-28 sm:py-36 overflow-hidden"
      data-testid="final-cta-section"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1473093295043-cdd812d0e601?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85"
          alt="Massa italiana servida"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0e1a13]/85 via-[#0e1a13]/75 to-[#0e1a13]" />
        <div className="absolute inset-0 sn-grain" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex justify-center text-[var(--sn-gold)] mb-7"
        >
          <Flourish className="w-40 h-5" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="font-display text-4xl sm:text-5xl lg:text-7xl text-[var(--sn-cream)] leading-[1.05] mb-7"
          data-testid="final-cta-headline"
        >
          Hoje é dia de{" "}
          <span className="italic gold-text">massa fresca</span> na sua mesa.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="text-[var(--sn-cream-soft)]/85 text-lg sm:text-xl max-w-2xl mx-auto mb-12 leading-relaxed font-body"
        >
          Encomende em segundos pelo WhatsApp e receba o melhor da tradição
          italiana, feito à mão para você.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="flex flex-col items-center gap-5"
        >
          <a
            href={buildWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-[var(--sn-whatsapp)] hover:bg-[var(--sn-whatsapp-hover)] text-white font-medium text-base sm:text-lg px-10 sm:px-14 py-5 sm:py-6 rounded-md transition-all hover:translate-y-[-3px] hover:shadow-[0_30px_60px_-15px_rgba(37,211,102,0.55)]"
            data-testid="final-cta-whatsapp-button"
          >
            <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
              <path d="M20.52 3.48A11.85 11.85 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 5.98L0 24l6.18-1.62A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52ZM12 22a9.93 9.93 0 0 1-5.07-1.39l-.36-.21-3.67.96.98-3.58-.23-.37A9.96 9.96 0 1 1 22 12c0 5.51-4.49 10-10 10Zm5.49-7.46c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.94 1.17-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.5a9.05 9.05 0 0 1-1.67-2.07c-.18-.3-.02-.46.13-.62.14-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.2-.24-.58-.49-.5-.66-.5l-.56-.01c-.2 0-.52.08-.79.37-.27.3-1.03 1-1.03 2.45s1.06 2.85 1.21 3.05c.15.2 2.08 3.17 5.04 4.45.7.3 1.25.48 1.68.62.7.22 1.34.2 1.85.12.56-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" />
            </svg>
            Pedir agora pelo WhatsApp
          </a>
          <p className="text-[var(--sn-gold)] text-sm tracking-widest">
            (19) 98228-2824
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
